import type { ISlotParams, ISlotBase, } from '@media-platform/slot/src/core/types';
import { slots } from './config';
import type * as T from './slots.types';
import { IS_DEVELOPMENT } from 'Src/constants/environment';
import { IPagesTypes } from 'Src/store/context/types';
export const getSlot = (alias: string, is_mobile: boolean, params?: ISlotParams, pageType?: IPagesTypes): ISlotBase | undefined => {
    const config = pageType && slots[pageType] ? slots[pageType] : slots.global;
    const groupConfig: T.ISlotsGroup = config
        ? config[is_mobile ? 'mobile' : 'desktop'] || {}
        : {};
    const slotConfig: ISlotBase | string = groupConfig[alias];
    if (!slotConfig) {
        if (IS_DEVELOPMENT && typeof window !== 'undefined') {
            window.console.warn(`Слот '${alias}' не найден`);
        }
        return;
    }
    if (typeof slotConfig === 'string') {
        return {
            id: slotConfig,
            params,
        };
    }
    return {
        ...slotConfig,
        params: {
            ...slotConfig.params,
            ...params,
        },
    };
};
